import { useCallback } from 'react';
import { useAsyncCallback } from '@react-hooks-library/core';

import { getImageryFavoritesApi } from '@services/imagery';
import { ImageryFavoritesResponse } from '@mytypes/imagery';

export const useGetImageryFavorites = () => {
  return useAsyncCallback(
    useCallback(
      async (input: { field_id: string; client_id: string; trial_id: string; protocol_id: string }): Promise<ImageryFavoritesResponse | undefined> => {
        try {
          const data = await getImageryFavoritesApi(input);

          return data;
        } catch (error) {
          console.error('An error occurred fetching imagery favorites', error);
          return undefined;
        }
      },
      []
    )
  );
};
